import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import ResourceBrowserContext from './ResourceBrowserContext';
import {
  StyledHeader,
  StyledActiveType,
  StyledCount,
} from './ResourceBrowserHeaderStyle';

const ResourceBrowserHeader = ({ count }) => {
  const { filters } = useContext(ResourceBrowserContext);

  const typeFilterPresent = filters.contentType.length !== 0;

  return (
    <StyledHeader>
      <div>
        <StyledActiveType level="3">
          {typeFilterPresent ? pluralize(filters.contentType[0].title) : 'All'}
        </StyledActiveType>
        <StyledCount>{`${count} results`}</StyledCount>
      </div>
    </StyledHeader>
  );
};

ResourceBrowserHeader.propTypes = {
  count: PropTypes.number.isRequired,
};

export default ResourceBrowserHeader;
